/* eslint-disable node/no-unsupported-features/es-syntax */
import { REPORTS_ROUTE_NAMES } from "@/shared";
export const REPORTS_ROUTES = [
    {
        name: REPORTS_ROUTE_NAMES.REPORTS,
        path: "/report",
        meta: {
            title: "menu.reports",
        },
        component: () => import("../ui/ReportApp.vue"),
    },
    {
        name: REPORTS_ROUTE_NAMES.REPORTS_ATTENDANCE,
        path: "/report/attendance",
        meta: {
            title: "words.attendance_report",
        },
        component: () => import("../ui/ReportAttendance.vue"),
    },
    {
        name: REPORTS_ROUTE_NAMES.REPORTS_EFFICIENCY,
        path: "/report/efficiency",
        meta: {
            title: "words.efficiency_report",
        },
        component: () => import("../ui/ReportEfficiency.vue"),
    },
    {
        name: REPORTS_ROUTE_NAMES.REPORTS_INCOME,
        path: "/report/income",
        meta: {
            title: "words.income_report",
        },
        component: () => import("../ui/ReportIncome.vue"),
    },
    {
        name: REPORTS_ROUTE_NAMES.REPORTS_PRODUCT_INCOME,
        path: "/report/product/income",
        meta: {
            title: "words.store_income_report",
        },
        component: () => import("../ui/ReportProductIncome.vue"),
    },
    {
        name: REPORTS_ROUTE_NAMES.REPORTS_PRODUCT_LEFTOVER,
        path: "/report/product/leftover",
        meta: {
            title: "words.remaining_stock_report",
        },
        component: () => import("../ui/ReportProductLeftover.vue"),
    },
    {
        name: REPORTS_ROUTE_NAMES.REPORTS_REVISE,
        path: "/report/revise",
        meta: {
            title: "words.reconciliation_report",
        },
        component: () => import("../ui/ReportRevise.vue"),
    },
    {
        name: REPORTS_ROUTE_NAMES.REPORTS_PAYMENTS,
        path: "/report/payments",
        meta: {
            title: "words.payment_flow_report",
        },
        component: () => import("../ui/ReportPayments.vue"),
    },
    {
        name: REPORTS_ROUTE_NAMES.REPORTS_PROFIT,
        path: "/report/profit",
        meta: {
            title: "Прибыль мастерской",
        },
        component: () => import("../ui/ReportProfit.vue"),
    },
];
